import type { SearchFormCriteria } from '@/widgets/searchForm';

export const EMPTY_CRITERIA: SearchFormCriteria = {
  fromCity: null,
  destination: null,
  nights: null,
  dateRange: null,
  tourists: null,
};
